"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _arcgisRestPortal = require("@esri/arcgis-rest-portal");
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var iconProps = {
  scale: "s",
  style: {
    display: "flex"
  }
};
var onActionComplete = function onActionComplete(_ref) {
  var query = _ref.query,
    handleQueryChange = _ref.handleQueryChange,
    clearSelectedItems = _ref.clearSelectedItems,
    start = _ref.start,
    num = _ref.num,
    id = _ref.id;
  setTimeout(function () {
    var updatedQuery = null;
    if (query) {
      updatedQuery = new _arcgisRestPortal.SearchQueryBuilder(query);
    }
    handleQueryChange && handleQueryChange({
      updatedQuery: updatedQuery,
      start: start,
      num: num,
      newActionUpdate: true,
      id: id
    });
    clearSelectedItems();
  }, 600);
};
var _moveItem = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item, queryResults, userSession, handleQueryChange, clearSelectedItems, selectedFolderId) {
    var itemData, itemMoved;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            itemData = queryResults.results.find(function (result) {
              return result.id === item;
            });
            _context.next = 4;
            return (0, _arcgisRestPortal.moveItem)({
              itemId: item,
              folderId: selectedFolderId,
              authentication: userSession,
              owner: itemData === null || itemData === void 0 ? void 0 : itemData.owner
            });
          case 4:
            itemMoved = _context.sent;
            if (itemMoved && itemMoved.success) {
              onActionComplete({
                query: queryResults === null || queryResults === void 0 ? void 0 : queryResults.query,
                handleQueryChange: handleQueryChange,
                clearSelectedItems: clearSelectedItems
              });
            }
            return _context.abrupt("return", itemMoved);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.warn(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function _moveItem(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var _shareItem = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, queryResults, userSession) {
    var itemData, itemShared;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            itemData = queryResults.results.find(function (result) {
              return result.id === item;
            }); // The following is not yet functional
            _context2.next = 3;
            return (0, _arcgisRestPortal.shareItemWithGroup)({
              id: item,
              groupId: "ade57fcbdb2c42f8ab9f4a93054fb3a",
              authentication: userSession,
              owner: itemData === null || itemData === void 0 ? void 0 : itemData.owner
            });
          case 3:
            itemShared = _context2.sent;
            return _context2.abrupt("return", itemShared);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function _shareItem(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
var _createNewFolder = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref4) {
    var _queryResults$results, _queryResults$results2;
    var folderName, userSession, getUserFolders, queryResults, newFolderCreated;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            folderName = _ref4.folderName, userSession = _ref4.userSession, getUserFolders = _ref4.getUserFolders, queryResults = _ref4.queryResults;
            _context3.next = 3;
            return (0, _arcgisRestPortal.createFolder)({
              title: folderName,
              authentication: userSession,
              owner: queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results = queryResults.results) === null || _queryResults$results === void 0 ? void 0 : (_queryResults$results2 = _queryResults$results[0]) === null || _queryResults$results2 === void 0 ? void 0 : _queryResults$results2.owner
            });
          case 3:
            newFolderCreated = _context3.sent;
            if (newFolderCreated && newFolderCreated.success) {
              getUserFolders && getUserFolders();
            }
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function _createNewFolder(_x10) {
    return _ref5.apply(this, arguments);
  };
}();
var _deleteItem = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(item, queryResults, userSession, handleQueryChange, clearSelectedItems) {
    var itemData, removedItemResult;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            itemData = queryResults.results.find(function (result) {
              return result.id === item;
            });
            _context4.next = 4;
            return (0, _arcgisRestPortal.removeItem)({
              id: item,
              authentication: userSession,
              owner: itemData === null || itemData === void 0 ? void 0 : itemData.owner
            });
          case 4:
            removedItemResult = _context4.sent;
            if (removedItemResult && removedItemResult.success) {
              onActionComplete({
                query: queryResults === null || queryResults === void 0 ? void 0 : queryResults.query,
                handleQueryChange: handleQueryChange,
                clearSelectedItems: clearSelectedItems
              });
            }
            return _context4.abrupt("return", removedItemResult);
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            console.warn(_context4.t0);
          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));
  return function _deleteItem(_x11, _x12, _x13, _x14, _x15) {
    return _ref6.apply(this, arguments);
  };
}();
var deleteItemAction = {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "trash"
  }, iconProps)),
  label: "Delete",
  // if true, the item browser modal will open
  enabledItemBrowserModal: true,
  onClick: function () {
    var _onClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref7) {
      var items, queryResults, userSession, handleQueryChange, clearSelectedItems;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              items = _ref7.items, queryResults = _ref7.queryResults, userSession = _ref7.userSession, handleQueryChange = _ref7.handleQueryChange, clearSelectedItems = _ref7.clearSelectedItems;
              if (!items.length) {
                _context5.next = 7;
                break;
              }
              _context5.next = 4;
              return Promise.all(items.map(function (item) {
                return _deleteItem(item, queryResults, userSession, handleQueryChange, clearSelectedItems);
              }));
            case 4:
              return _context5.abrupt("return", _context5.sent);
            case 7:
              _context5.next = 9;
              return _deleteItem(items, queryResults, userSession, handleQueryChange, clearSelectedItems);
            case 9:
              return _context5.abrupt("return", _context5.sent);
            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    function onClick(_x16) {
      return _onClick.apply(this, arguments);
    }
    return onClick;
  }(),
  id: "delete"
};
var moveItemAction = {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "folder-move"
  }, iconProps)),
  label: "Move",
  enabledItemBrowserModal: true,
  onClick: function () {
    var _onClick2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref8) {
      var items, queryResults, userSession, handleQueryChange, clearSelectedItems, selectedFolderId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              items = _ref8.items, queryResults = _ref8.queryResults, userSession = _ref8.userSession, handleQueryChange = _ref8.handleQueryChange, clearSelectedItems = _ref8.clearSelectedItems, selectedFolderId = _ref8.selectedFolderId;
              if (!items.length) {
                _context6.next = 7;
                break;
              }
              _context6.next = 4;
              return Promise.all(items.map(function (item) {
                return _moveItem(item, queryResults, userSession, handleQueryChange, clearSelectedItems, selectedFolderId);
              }));
            case 4:
              return _context6.abrupt("return", _context6.sent);
            case 7:
              _context6.next = 9;
              return _moveItem(items, queryResults, userSession, handleQueryChange, clearSelectedItems, selectedFolderId);
            case 9:
              return _context6.abrupt("return", _context6.sent);
            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    function onClick(_x17) {
      return _onClick2.apply(this, arguments);
    }
    return onClick;
  }(),
  id: "move"
};
var shareItemAction = {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "share"
  }, iconProps)),
  label: "Share",
  enabledItemBrowserModal: true,
  onClick: function () {
    var _onClick3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref9) {
      var items, queryResults, userSession;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              items = _ref9.items, queryResults = _ref9.queryResults, userSession = _ref9.userSession;
              if (!items.length) {
                _context7.next = 7;
                break;
              }
              _context7.next = 4;
              return Promise.all(items.map(function (item) {
                return _shareItem(item, queryResults, userSession);
              }));
            case 4:
              return _context7.abrupt("return", _context7.sent);
            case 7:
              _context7.next = 9;
              return _shareItem(userSession);
            case 9:
              return _context7.abrupt("return", _context7.sent);
            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    function onClick(_x18) {
      return _onClick3.apply(this, arguments);
    }
    return onClick;
  }(),
  id: "share"
};
var _default = {
  deleteItem: deleteItemAction,
  createFolder: _createNewFolder,
  moveItem: moveItemAction,
  shareItem: shareItemAction,
  onActionComplete: onActionComplete
};
exports.default = _default;